import { Table } from 'antd';
import React, { useContext, useMemo } from 'react';

import type { GroupBuying } from '@/types/database/groupBuying';
import type { User } from '@/types/database/users';
import useService from '@/lib/hooks/useService';

import { GroupBuyingOrdersContext } from '../OrderManagement';
import { getTableColumns, getTableDataSource } from './helper';

interface OrdersListProps {
  listType: '現在團購' | '歷史資料';
}

const CurrentOrder = ({ listType }: OrdersListProps) => {
  const [groupBuyingItems] = useService<GroupBuying>({
    collectionName: 'groupBuying',
  });
  const [users] = useService<User>({ collectionName: 'users' });
  const { currentOrders, historyOrders } = useContext(GroupBuyingOrdersContext);

  const tableColumns = useMemo(() => getTableColumns(listType), [listType]);

  return (
    <Table
      scroll={{ x: 1200 }}
      columns={tableColumns}
      dataSource={getTableDataSource({
        users,
        groupBuyingItems,
        orders: listType === '現在團購' ? currentOrders : historyOrders,
        listType,
      })}
      rowKey="_id"
    />
  );
};

export default CurrentOrder;
